import { get as getLocalStorage, set as setLocalStorage } from 'lib/storage/isomorphicLocalStorage'

export const DISMISSED_BANNER_STORAGE_KEY = 'luxPlusFreePreviewBannerDismissed'

export function getDismissed() {
  return getLocalStorage(DISMISSED_BANNER_STORAGE_KEY) ?? false
}

export function setDismissed() {
  setLocalStorage(DISMISSED_BANNER_STORAGE_KEY, true)
}
